module.exports = __webpack_public_path__ + "img/top-4-5.b3d63e8d.jpg";